<template>
  <section class="bacon">
    <div class="bacon-holder">
      <img v-for="x in 3" src="../../assets/bacon.svg">
    </div>
    <h2>{{title}}</h2>
    <span class="line"></span>
  </section>
</template>

<script>
  export default {

    props: {
      id: String,
      name: String,
      title: String
    },
  }
</script>


<style lang="scss">
  @import "../../css/bacon.scss";
</style>


// WEBPACK FOOTER //
// bacon.vue?a7e31838